import React from "react";
import { Layout, Button, Badge } from "antd";
//redux
import { connect } from "react-redux";
//auth
import { logout } from "../redux/actions/authActions";
//assets
import logo from "./logo.svg";
const { Header, Content, Footer } = Layout;

const AppLayout = props => {
  return (
    <Layout className="layout">
      <Header style={styles.header}>
        <img style={styles.logo} src={logo} className="logo" alt="logo" />
        <div style={{ marginRight: "5%" }}>
          {props.job && (
            <span style={{ marginRight: "24px" }}>
              <Badge
                style={{ marginRight: "12px" }}
                status={props.profileIndex ? "default" : "success"}
                text={props.profileIndex ? "Unsaved" : "Saved"}
              />
              {(props.job.progress + props.profileIndex >
              props.job.endIndex - props.job.startIndex //if progress + profileIndex greater than max when done, than show max
                ? props.job.endIndex - props.job.startIndex
                : props.job.progress + props.profileIndex) +
                "/" +
                (props.job.endIndex - props.job.startIndex)}
            </span>
          )}
          <span style={{ marginRight: "24px" }}>
            <b>{props.name}</b>
          </span>
          <Button onClick={logout}>Sign Out</Button>
        </div>
      </Header>
      <Content style={{ padding: "0 1vw", height: "90vh" }}>
        <div
          style={{
            background: "#fff",
            padding: 24,
            height: "90vh",
          }}
        >
          {
            props.children //Main.js
          }
        </div>
      </Content>
    </Layout>
  );
};
const styles = {
  logo: {
    maxWidth: "40%",
    maxHeight: "66%",
    padding: 0,
    marginLeft: "5%",
  },
  header: {
    padding: 0,
    margin: 0,
    backgroundColor: "#fff",
    display: "flex",
    flexWrap: "no-wrap",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 1px 0 rgba(0,0,0,.1)",
    zIndex: 99,
    maxWidth: "100%",
  },
};

const mapStateToProps = state => {
  return {
    job: (state.data && state.data.job) || null,
    profileIndex: (state.data && state.data.profileIndex) || 0, //if profile index not zero, there is unsaved progress
    name: (state.auth && state.auth.user && state.auth.user.name) || null, //access 'data' attribute of Redux state as this.props.data
  };
};

export default connect(mapStateToProps)(AppLayout);
